WDN.Storage = (function () {
  var defaultConfig = {
    type: "session",
    onlyJSON: false,
    namespace: "",
  };

  var getLocalConfig = function () {
    return Object.assign({}, defaultConfig);
  };

  var StorageReader = function (config) {
    this.config = Object.assign(getLocalConfig(), config);

    this.storer = function (name, value) {
      if (!value || !name) {
        return false;
      }

      name = this.config.namespace + name;

      if (this.config.type && this.config.type === "session") {
        sessionStorage.setItem(name, value);
      } else {
        localStorage.setItem(name, value);
      }

      this.notify("set", name, value);
    };

    this.loader = function (name) {
      if (!name) {
        return false;
      }

      name = this.config.namespace + name;

      var value = localStorage.getItem(name);

      if (this.config.type && this.config.type === "session") {
        value = sessionStorage.getItem(name);
      }

      return value;
    };

    this.removeItem = function (name) {
      if (!name) {
        return;
      }

      if (this.config.type && this.config.type === "session") {
        sessionStorage.removeItem(name);
      } else {
        localStorage.removeItem(name);
      }
    };

    // notifier
    this.onChange = {};

    this.notify = function (event_name, name, value) {
      if (event_name == "set") {
        if (this.onChange.set) {
          this.onChange.set(name, value);
        }
      }
    };

    this.on = function (event_name, callback) {
      this.onChange[event_name] = callback;
    };

    this.set = function (name, value) {
      if (!value) {
        return false;
      }

      this.storer(name, value);
    };

    this.get = function (name) {
      if (!name) {
        return false;
      }

      return this.loader(name);
    };

    this.remove = function (name) {
      name = this.config.namespace + name;

      if (this.config.type && this.config.type === "session") {
        sessionStorage.removeItem(name);
      } else {
        localStorage.removeItem(name);
      }
    };

    this.getAsJSON = function (name) {
      return JSON.parse(this.loader(name));
    };

    this.getJSON = function (name) {
      return this.getAsJSON(name);
    };

    this.setAsJSON = function (name, value) {
      this.storer(name, JSON.stringify(value));
      return this.getJSON(name);
    };

    this.setJSON = function (name, value) {
      return this.setAsJSON(name, value);
    };

    if (this.config.onlyJSON) {
      this.get = this.getJSON;
      this.set = this.setJSON;
    }

    // Alias list
    this.save = this.set;
    this.load = this.get;
    this.read = this.get;
    this.clear = this.remove;
  };

  return StorageReader;
})();
